import type { CandleWithFlag } from "features/chart";

function sma(values: (number | null)[], period: number): (number | null)[] {
  const result: (number | null)[] = [];
  for (let i = 0; i < values.length; i++) {
    if (i < period - 1) { result.push(null); continue; }
    let sum = 0;
    let valid = true;
    for (let j = i - period + 1; j <= i; j++) {
      if (values[j] === null) { valid = false; break; }
      sum += values[j] as number;
    }
    result.push(valid ? sum / period : null);
  }
  return result;
}

export interface ACPoint {
  index: number;
  value: number;
  up: boolean;
}

export function calcAcceleratorOscillator(
  data: CandleWithFlag[],
  aoShort: number,
  aoLong: number,
  acSma: number,
): ACPoint[] {
  const medians: (number | null)[] = data.map(c =>
    c.high !== undefined && c.low !== undefined ? (c.high + c.low) / 2 : null
  );
  const shortSma = sma(medians, aoShort);
  const longSma = sma(medians, aoLong);
  const ao: (number | null)[] = shortSma.map((s, i) => {
    const l = longSma[i];
    return s !== null && l !== null ? s - l : null;
  });
  const aoSma = sma(ao, acSma);

  const result: ACPoint[] = [];
  let prev: number | null = null;
  data.forEach((_, i) => {
    const a = ao[i];
    const sm = aoSma[i];
    if (a === null || sm === null) return;
    const value = a - sm;
    result.push({ index: i, value, up: prev === null || value > prev });
    prev = value;
  });
  return result;
}
